import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Apis } from "../../config";
import apiService from "../../services/ApiService";

const fetchRequestCount = createAsyncThunk('fetch/requestCount', async (userId, { rejectWithValue }) => {
    try {
        let response = await apiService.get(Apis.GetRequestCount(userId))
        return response
    } catch (err) {
        return rejectWithValue(err?.message)
    }
});

export const requestCountThunk = { fetchRequestCount };
